import {
  Box,
  Button,
  CheckIcon,
  DismissIcon,
  Flex,
  Typography,
} from '@iheartjane/reefer';
import { Form } from '@iheartjane/reefer-hook-form';
import { useEffect, useRef } from 'react';

import styles from './promoCodes.module.css';

interface Props {
  hasValidationError: boolean;
  name: string;
  onReset: () => void;
  onSubmit: (value: string) => void;
  placeholder: string;
  submitLabel: string;
  validated: boolean;
  validationMessage?: string;
}

export const SubmittableTextInput = ({
  onReset,
  onSubmit,
  placeholder,
  submitLabel,
  validated,
  hasValidationError,
  validationMessage,
  name,
}: Props) => {
  const validationMessageRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const handleSubmit = (values: any) => {
    onSubmit(values[name]);
  };

  useEffect(() => {
    if (validated) {
      validationMessageRef.current?.focus();
    } else {
      inputRef.current?.focus();
    }
  }, [validated, name]);

  return (
    <Form name="promocode-form" onSubmit={handleSubmit}>
      <Flex alignItems="center" justifyContent="stretch" overflow="hidden">
        {!validated && (
          <Form.TextField
            className={styles['textField']}
            disableMobileInputStyling
            labelHidden
            label="Promo code"
            name={name}
            aria-label={name}
            placeholder={placeholder}
            ref={inputRef}
          />
        )}
        {!validated && (
          <Box width={124} pl={24}>
            <Form.SubmitButton label={submitLabel} full />
          </Box>
        )}
        {validated && hasValidationError && (
          <Button.Icon
            icon={<DismissIcon aria-label="remove invalid code" />}
            onClick={() => {
              onReset();
            }}
            type="button"
            variant="destructive"
            full
          />
        )}
        {validated && !hasValidationError && <CheckIcon color="success" />}
        {validated && (
          <div ref={validationMessageRef} tabIndex={-1}>
            <Typography
              color={hasValidationError ? 'error' : 'success'}
              whiteSpace="nowrap"
              pl={24}
            >
              {validationMessage}
            </Typography>
          </div>
        )}
      </Flex>
    </Form>
  );
};
